import { MailAdd01Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const MailPlus = /* @__PURE__ */ createIcon(MailAdd01Icon, 'MailPlus');
